
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { LazyImageRandomColors as randomColors } from '@xt/client/helpers/constant'

@Component({
  components: {}
})
class Index extends Vue {
  @Prop() className
  @Prop() src
  @Prop() styles
  @Prop({ default: false }) noBackground
  @Prop({ default: false }) crossOrigin: boolean

  isError: boolean = false
  fun: () => void

  get color() {
    return this.hasLoaded ? 'rgba(0, 0, 0, 0)' : !this.noBackground ? randomColors[Math.floor(Math.random() * 6)] : 'rgba(0, 0, 0, 0)'
  }

  get LazyImgLoadedSet() {
    return this.$lazyImgLoadedSet
  }

  get hasLoaded() {
    return this.LazyImgLoadedSet.hasLazyImg(this.src)
  }

  @Emit('click')
  click() {}
  @Emit('onLoadImg')
  onLoadImg() {
    // 启用图片url记录，用于强缓存请求时不需要再次使用color色块
    this.LazyImgLoadedSet.addLazyImg(this.src)
  }
  @Emit('onLoadError')
  onLoadError() {}

  mounted() {}

  destroyed() {}
}

export default Index
